<template>
  <div class="container mx-auto" :class="$style.scrollBarHidden">
    <TitleWrapper
      :filter-option="true"
      title="ANNOUNCEMENTS_REMINDERS"
      tooltip-title="ANNOUNCEMENTS_REMINDERS"
      :display-breadcrumb="true"
    >
      <template v-slot:filterItems>
        <div>
          <div
            v-i18n="dashboard"
            class="font-roboto font-normal text-text-color text-base sm:text-xl mb-4"
          >
            Search Notification
          </div>
          <div class="filter-block pb-6">
            <section class="input-field customCalenderSelect">
              <UiSingleSelect title="Notification" label="title" :options="[]" class="flex-1" />
            </section>
          </div>
        </div>
      </template>
    </TitleWrapper>
    <div class="bg-bg-color-white rounded-lg mt-5 px-7 border border-primary-grey pb-10">
      <div
        class="font-roboto font-normal items-center notification-text-color sm:text-lg text-base pt-7 pb-5 flex justify-between w-full"
      >
        <div>Announcements List</div>
        <div>
          <button
            v-i18n="dashboard"
            class="sm:px-5 px-2 py-1.5 text-sm text-primary-purple-700 border border-primary-purple-700 rounded-md"
            :disabled="isAllAnnouncementsRead"
            @click="markAllAsRead()"
          >
            Mark all as Read
          </button>
        </div>
      </div>
      <div class="border-t border-primary-grey mb-5"></div>
      <div v-if="announcementsList.length">
        <NotificationItem
          :announcement="true"
          :increase-size="true"
          :title-limit="isMobile ? 31 : 100"
          :notifications="announcementsList"
          class="rounded-md pb-2 pt-1 flex flex-col gap-2"
          :custom-style="true"
          @notificationAction="announcementAction"
        />
      </div>
      <div v-else>
        <p class="text-center text-gray-500">No announcements available.</p>
      </div>
      <div class="border-t border-primary-grey mt-5">
        <Pagination
          :record-limit="filteredRecordLimit"
          :max-range="paginationCounts(totalCount, filteredRecordLimit)"
          @filterRecord="filterRecord"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TitleWrapper from '@components/TitleWrapper.vue'
import Pagination from '@components/BaseComponent/Pagination.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import NotificationItem from './NotificationItem.vue'
import { NOTIFICATION_STATUS } from '@src/constants/general-constants'
import generalUtil from '@src/mixins/general-mixins.js'

export default {
  components: {
    TitleWrapper,
    NotificationItem,
    Pagination,
    UiSingleSelect,
  },
  mixins: [generalUtil],

  data() {
    return {
      isMobile: window.matchMedia('(max-width: 1023px)').matches,
      notifications: [],
      announcementCounts: null,
      dashboard: 'dashboard',
      totalCount: 0,
      showPagination: false,
      filteredRecordLimit: 10,
    }
  },
  computed: {
    ...mapState({
      announcementsList: (state) => state.notifications.announcements,
    }),
    isAllAnnouncementsRead() {
      return this.announcementsList.every((announcement) => announcement.status === 'read')
    },
  },
  created() {
    this.filterRecord()
  },
  methods: {
    ...mapActions('notifications', ['getAnnouncements', 'setNotificationStatus']),

    filterRecord(range) {
      const payload = { skip: range?.skip || 0, limit: range?.limit || 10 }
      this.getAnnouncements(payload).then((response) => {
        this.totalCount = response.data.total_count
        this.showPagination = this.announcementsList.length > 10
        this.announcementCounts = this.announcementsList.length
      })
    },

    announcementAction(payload) {
      this.setNotificationStatus({
        notification_ids: [payload?.id],
        status: payload?.action,
      }).then(() => {
        this.$store.commit('notifications/UPDATE_ANNOUNCEMENT_STATUS', payload)
        this.$store.commit('notifications/SET_UNREAD_ANNOUNCEMENTS_COUNT', 'decrement')
      })
    },

    markAllAsRead() {
      const unreadAnnouncementIDs = this.announcementsList
        .filter((announcement) => announcement.status === 'unread')
        .map((announcement) => announcement.id)

      for (const id of unreadAnnouncementIDs) {
        this.setNotificationStatus({
          notification_ids: [id],
          status: 'read',
        }).then(() => {
          const payload = { id, action: 'read' }
          this.$store.commit('notifications/UPDATE_ANNOUNCEMENT_STATUS', payload)
          this.$store.commit('notifications/SET_UNREAD_ANNOUNCEMENTS_COUNT', 'decrement')
        })
      }
    },
  },
}
</script>

<style lang="scss" module>
.scrollBarHidden {
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>

<style lang="scss">
.notification-text-color {
  color: var(--text-color-darker);
}
</style>
